// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file game.proto (package crossme, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Fill } from "./fill_pb";
import { file_fill } from "./fill_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file game.proto.
 */
export const file_game: GenFile = /*@__PURE__*/
  fileDesc("CgpnYW1lLnByb3RvEgdjcm9zc21lIrMBCgRHYW1lEgoKAmlkGAEgASgJEhEKCXB1enpsZV9pZBgCIAEoCRIbCgRmaWxsGAMgASgLMg0uY3Jvc3NtZS5GaWxsEisKB2NyZWF0ZWQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjAKDGNvbXBsZXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEAoIb3duZXJfaWQYBiABKAlCFFoSY3Jvc3NtZS5hcHAvc3JjL3BiYgZwcm90bzM", [file_fill, file_google_protobuf_timestamp]);

/**
 * @generated from message crossme.Game
 */
export type Game = Message<"crossme.Game"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string puzzle_id = 2;
   */
  puzzleId: string;

  /**
   * @generated from field: crossme.Fill fill = 3;
   */
  fill?: Fill | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created = 4;
   */
  created?: Timestamp | undefined;

  /**
   * Set (by the server) when the fill was verified complete; unset
   * for games still in progress. `fill.complete` is the CRDT-visible
   * flag; this records when the game froze.
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 5;
   */
  completedAt?: Timestamp | undefined;

  /**
   * The User who created this game; empty for games created
   * anonymously.
   *
   * @generated from field: string owner_id = 6;
   */
  ownerId: string;
};

/**
 * Describes the message crossme.Game.
 * Use `create(GameSchema)` to create a new message.
 */
export const GameSchema: GenMessage<Game> = /*@__PURE__*/
  messageDesc(file_game, 0);

